import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, toRef, watch } from 'vue'
import { storeToRefs } from 'pinia'

import TransportationLocationSelector from '../TransportationLocationSelector.vue'
import TransportationDateTimeRangePicker from '../TransportationDateTimeRangePicker.vue'
import TransportationEmojiLabelField from '../TransportationEmojiLabelField.vue'
import DocumentManager from '../../documents/manager/DocumentManager.vue'
import FlightLookup from './flight/FlightLookup.vue'
import FlightStatus from './flight/FlightStatus.vue'
import FormGroup from '@/components/core/form/FormGroup.vue'
import LInput from '@/components/core/form/Input.vue'
import LTextarea from '@/components/core/form/Textarea.vue'
import { useSelectedTrip } from '@/composables/trip'
import { useRouteManagement } from '@/composables/route'
import { useTransportationDocuments } from '@/composables/transportation'
import { useTransportationStore } from '@/stores/transportation'
import {
  FlightDetailsNew,
  FlightTransportationUIInput,
  isPersistedUITransportation,
} from '@/types/transportation'
import { locationToAutocompleteResult } from '@/utils/location'


export default /*#__PURE__*/_defineComponent({
  __name: 'FlightForm',
  props: {
    transportation: null,
    waypointId: null
  },
  setup(__props: any) {

const props = __props as {
  transportation: FlightTransportationUIInput
  waypointId: string
};



const trip = useSelectedTrip()
const transportationStore = useTransportationStore()
const { isSaveDisabled } = storeToRefs(transportationStore)
const transportation = toRef(props, 'transportation')

const idPrefix = computed(() => {
  return `transportation-${transportation.value._id ?? 'flight-new'}`
})

// Document Management ---------------------------------------------------------

const managedDocuments = useTransportationDocuments(transportation)

// Route Management ------------------------------------------------------------

const { calculateRoutes } = useRouteManagement(transportation)

watch(
  [() => transportation.value.origin, () => transportation.value.destination],
  async () => await calculateRoutes(),
)

onMounted(async () => {
  if (!transportation.value.route) {
    await calculateRoutes()
  }
})

// Show/Hide More Content ------------------------------------------------------

const hasContentInMoreSection = !!(
  managedDocuments.value.length > 0 ||
  transportation.value.provider ||
  transportation.value.bookingReference ||
  transportation.value.flightNumber ||
  transportation.value.seatNumber ||
  transportation.value.comment
)

const showContent = ref(hasContentInMoreSection)

function toggleMoreContent() {
  showContent.value = !showContent.value
}

// Flight Lookup Logic ---------------------------------------------------------

const showFlightLookup = ref(!isPersistedUITransportation(transportation.value))

function onManualEntry(prefilledFlightDetails: {
  flightNumber?: string
  departureDate?: string
}) {
  transportation.value.flightNumber = prefilledFlightDetails.flightNumber
  transportation.value.period = {
    start: prefilledFlightDetails.departureDate,
    end: prefilledFlightDetails.departureDate,
  }

  showFlightLookup.value = false
}

function onFlightFound(flightDetails: FlightDetailsNew) {
  transportation.value.provider = flightDetails.airline
  transportation.value.flightNumber = flightDetails.flightNumber
  transportation.value.departureAirport = flightDetails.departure.airport
  transportation.value.arrivalAirport = flightDetails.arrival.airport
  transportation.value.period = {
    start: flightDetails.departure.date,
    end: flightDetails.arrival.date,
  }
  transportation.value.origin = flightDetails.departure.airport.location
    ? locationToAutocompleteResult(flightDetails.departure.airport.location)
    : undefined
  transportation.value.destination = flightDetails.arrival.airport.location
    ? locationToAutocompleteResult(flightDetails.arrival.airport.location)
    : undefined
  transportation.value.label = flightDetails.label

  showFlightLookup.value = false
}

watch(
  showFlightLookup,
  (newValue) => {
    isSaveDisabled.value = newValue
  },
  { immediate: true },
)

return { __sfc: true,props, trip, transportationStore, isSaveDisabled, transportation, idPrefix, managedDocuments, calculateRoutes, hasContentInMoreSection, showContent, toggleMoreContent, showFlightLookup, onManualEntry, onFlightFound, TransportationLocationSelector, TransportationDateTimeRangePicker, TransportationEmojiLabelField, DocumentManager, FlightLookup, FlightStatus, FormGroup, LInput, LTextarea }
}

})